import React, { FC } from 'react';
import { Chip, ChipsWrapper, ChipsInnerWrapper } from './CommonCarousel';

type Props = {
  children: (resetScroll: Function) => React.ReactNode;
};

export const TouchCarousel: FC<Props> = ({ children }) => {
  return (
    <Chip>
      <ChipsWrapper>
        <ChipsInnerWrapper>{children(() => null)}</ChipsInnerWrapper>
      </ChipsWrapper>
    </Chip>
  );
};
